import { persist, createJSONStorage, StateStorage } from 'zustand/middleware';

/**
 * 创建自定义存储适配器
 */
export const createCustomStorage = (): StateStorage => {
  const isDesktop = typeof window !== 'undefined' && window.desktopIdentity;

  if (isDesktop && window.store) {
    return {
      getItem: async (name: string): Promise<string | null> => {
        const value = await window.store.get(name);
        return value ?? null;
      },
      setItem: async (name: string, value: string): Promise<void> => {
        await window.store.set(name, value);
      },
      removeItem: async (name: string): Promise<void> => {
        await window.store.delete(name);
      },
    };
  } else {
    return {
      getItem: (name: string): string | null => {
        return localStorage.getItem(name);
      },
      setItem: (name: string, value: string): void => {
        localStorage.setItem(name, value);
      },
      removeItem: (name: string): void => {
        localStorage.removeItem(name);
      },
    };
  }
};
/**
 * 自定义 persist 中间件
 */
export const customPersist: typeof persist = (config, options) => {
  return persist(config, {
    ...options,
    // FIXED: 无法缓存, 此文件第一次进入时间，比root.renderer第一次执行时间要早。访问很可能不是 windows.store
    storage: createJSONStorage(() => createCustomStorage()),
  });
};
